import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { RateModelDto } from '../models/ratemodeldto';
import { PaginationFeaturesDto } from '../models/paginationfeaturesdto';
import { AppConfigService } from './core/appConfig.service';

@Injectable({
  providedIn: 'root'
})
export class TaxesService {

  constructor(private http: HttpClient, private configService: AppConfigService) { }

  /**
   * Función encargada de listar todos modelosde tasas segun filtro
   * @param type
   * @param filter
   * @returns 
   */
  getListTaxesByFilters(pageRequest: PaginationFeaturesDto, type: string, filter: any): Observable<any> {
    const params = new HttpParams()
      .set('page', pageRequest.page)
      .set('sizePage', pageRequest.sizePage)
      .set('orderField', "idRateModel")
      .set('order', pageRequest.order);
    const url = `${this.configService.apiUrl}/configuration/rate-model/listAll?${params}&typology=${type}&codeModel=${filter.controls.codeModel.value}&status=${filter.controls.status.value}`;
    return this.http.get<any>(url).pipe(map(response => { return response; }));
  }

  getListTaxesAll(pageRequest: PaginationFeaturesDto): Observable<any> {
    const params = new HttpParams()
      .set('page', pageRequest.page)
      .set('sizePage', pageRequest.sizePage)
      .set('orderField', "idRateModel")
      .set('order', pageRequest.order);
    const url = `${this.configService.apiUrl}/configuration/rate-model/listAll?${params}&typology=&codeModel=&status=S`;
    return this.http.get<any>(url).pipe(map(response => { return response; }));
  }
  /**
   * Función encargada de insertar un nuevo modelo de tasa
   * @param RateModelDto 
   * @returns 
   */
  insertRateModel(RateModelDto: RateModelDto): Observable<any> {
    const url = `${this.configService.apiUrl}/configuration/rate-model/insert`;
    return this.http.post<any>(url, RateModelDto).pipe(map(response => { return response; }));
  }

  /**
   * Función encargada de actualizar un modelo de tasa
   * @param actionBoolean 
   * @param RateModelDto 
   * @returns 
   */
  updateRateModel(actionBoolean: boolean, RateModelDto: RateModelDto): Observable<any> {
    const url = `${this.configService.apiUrl}/configuration/rate-model/update/${actionBoolean}`;
    return this.http.put<any>(url, RateModelDto).pipe(map(response => { return response; }));
  }

  cloneModel(idRateModel: number | null): Observable<any> {
    const url = `${this.configService.apiUrl}/configuration/rate-model/duplicate/${idRateModel}`;
    return this.http.post<any>(url, RateModelDto).pipe(map(response => { return response; }));
  }

  /**
   * Solicita al backend la exportación de modelos de tarifa y recibe el Excel en binario.
   * El servidor responde con un XLSX; por eso pedimos la respuesta como `blob`
   * para poder forzar la descarga en el navegador.
   *
   * @arrayRateModel ids  Id o lista de ids (p.ej. 5, "5" o [1,2,3]).
   * @returns    Observable<Blob> con el contenido del fichero XLSX.
   */
  exportModel(arrayRateModel: any): Observable<any> {
    const url = `${this.configService.apiUrl}/configuration/rate-model/export`;
    const idsParam = Array.isArray(arrayRateModel) ? arrayRateModel.join(',') : String(arrayRateModel);
    return this.http.get(url, {
      params: { listRateModelIds: idsParam },
      responseType: 'blob',
      observe: 'response', // Con esto, obtenemos los headers enviados desde el backend
    });
  }

  getRateModelByCode(codeRateModel: string): Observable<any> {
    const url = `${this.configService.apiUrl}/configuration/rate-model/filter/${codeRateModel}`;
    return this.http.get<any>(url).pipe(map(response => { return new RateModelDto(response); }));
  }

}

